import { host_url } from "../configiration/config";
export function imgResize(path,w,h){
    if(!h) h = 0;
    return host_url+'/'+path+"?w="+w+"&h="+h;
}